import ACTION_TYPES from '../../constants/actionTypes';
import find from 'lodash/find';
import get from 'lodash/get';
import api from '../../api';

/*
 * Airlines
 * ========================================
 */

function getAirlinesRequest() {
  return {
    type: ACTION_TYPES.GET_AIRLINES,
  };
}

function getAirlinesSuccess(airlines) {
  return {
    type: ACTION_TYPES.GET_AIRLINES_SUCCESS,
    airlines,
  };
}

function getAirlinesFailure(error) {
  return {
    type: ACTION_TYPES.GET_AIRLINES_FAILURE,
    error,
  };
}

export function getAirlines() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch(getAirlinesRequest());
      api
        .getAirlines()
        .then(airlines => {
          dispatch(getAirlinesSuccess(airlines));
          resolve(airlines);
        })
        .catch(error => {
          dispatch(getAirlinesFailure(error));
          reject(error);
        });
    });
  };
}

/*
 * Baggage address
 * ========================================
 */

export function saveBaggageLocation(locationInfo) {
  return {
    type: ACTION_TYPES.SAVE_BAGGAGE_LOCATION,
    locationInfo,
  };
}

/*
 * Baggage airline
 * ========================================
 */

export function saveBaggageAirline(fsCode) {
  return {
    type: ACTION_TYPES.SAVE_BAGGAGE_AIRLINE,
    fsCode,
  };
}

/*
 * Baggage confirmation number
 * ========================================
 */

export function saveBaggageConfirmationViewNumber(confirmationNumber) {
  return {
    type: ACTION_TYPES.SAVE_BAGGAGE_CONFIRMATION_NUMBER,
    confirmationNumber,
  };
}

/*
 * Baggage passenger info
 * ========================================
 */

export function saveBaggagePassengerInfo(passengerInfo = {}) {
  return {
    type: ACTION_TYPES.SAVE_BAGGAGE_PASSENGER_INFO,
    payload: passengerInfo,
  };
}

/*
 * Baggage plans
 * ========================================
 */

function getBaggagePlansViewRequest() {
  return {
    type: ACTION_TYPES.GET_BAGGAGE_PLANS,
  };
}

function getBaggagePlansViewSuccess(data) {
  return {
    type: ACTION_TYPES.GET_BAGGAGE_PLANS_SUCCESS,
    data,
  };
}

function getBaggagePlansViewFailure(error) {
  return {
    type: ACTION_TYPES.GET_BAGGAGE_PLANS_FAILURE,
    error,
  };
}

export function getBaggagePlansView(details) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { baggageLocation } = getState();
      dispatch(getBaggagePlansViewRequest());
      api
        .getBaggagePlansView(baggageLocation.lat, baggageLocation.lng)
        .then(plans => {
          dispatch(getBaggagePlansViewSuccess(plans));
          resolve(plans);
        })
        .catch(error => {
          dispatch(getBaggagePlansViewFailure(error));
          reject(error);
        });
    });
  };
}

/*
 * Baggage plan selection
 * ========================================
 */

export function selectBaggagePlan(planId) {
  return {
    type: ACTION_TYPES.SELECT_BAGGAGE_PLAN,
    payload: {
      planId,
    },
  };
}

/*
 * Baggage checkout
 * ========================================
 */

function checkoutBaggageRequest(planId) {
  return {
    type: ACTION_TYPES.CHECKOUT_BAGGAGE,
    planId,
  };
}

function checkoutBaggageSuccess(data) {
  return {
    type: ACTION_TYPES.CHECKOUT_BAGGAGE_SUCCESS,
    data,
  };
}

function checkoutBaggageFailure(error) {
  return {
    type: ACTION_TYPES.CHECKOUT_BAGGAGE_FAILURE,
    error,
  };
}

export function checkoutBaggagePlan() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const {
        baggageAirline,
        baggagePassengerInfo,
        baggageLocation,
        baggageConfirmationNumber,
        baggageSelectedPlanId,
      } = getState();
      const opts = {
        lat: baggageLocation.lat,
        lng: baggageLocation.lng,
        planId: baggageSelectedPlanId,
        airline: baggageAirline,
        email: baggagePassengerInfo.email,
        firstName: baggagePassengerInfo.firstName,
        middleName: baggagePassengerInfo.middleName,
        lastName: baggagePassengerInfo.lastName,
        phone: baggagePassengerInfo.phone,
        confirmationNumber: baggageConfirmationNumber,
      };

      dispatch(checkoutBaggageRequest(baggageSelectedPlanId));
      api
        .getBaggageCheckout(opts)
        .then(checkout => {
          dispatch(checkoutBaggageSuccess(checkout));
          resolve(checkout);
        })
        .catch(error => {
          dispatch(checkoutBaggageFailure(error));
          reject(error);
        });
    });
  };
}

/*
 * Purchase baggage plan
 * ========================================
 */

function startBaggagePurchase() {
  return {
    type: ACTION_TYPES.PURCHASE_BAGGAGE,
  };
}

function baggagePurchaseSuccess(data) {
  return {
    type: ACTION_TYPES.PURCHASE_BAGGAGE_SUCCESS,
    data,
  };
}

function baggagePurchaseError(error) {
  return {
    type: ACTION_TYPES.PURCHASE_BAGGAGE_FAILURE,
    error,
  };
}

export function purchaseBaggage(cardElement) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const {
        authToken,
        baggageAirline,
        baggageCheckout,
        baggageConfirmationNumber,
        baggageLocation,
        baggagePassengerInfo,
        baggagePlans,
        baggageSelectedPlanId,
      } = getState();
      const selectedPlan = find(baggagePlans, {
        plan_id: baggageSelectedPlanId,
      });
      const details = {
        airline_fs_code: baggageAirline,
        pax_email: baggagePassengerInfo.email,
        pax_first_name: baggagePassengerInfo.firstName,
        pax_middle_name: baggagePassengerInfo.middleName,
        pax_last_name: baggagePassengerInfo.lastName,
        pax_phone: baggagePassengerInfo.phone,
        pnr_code: '' + baggageConfirmationNumber,
      };
      const revenue = get(baggageCheckout, 'totals.grandtotal');
      dispatch(startBaggagePurchase());
      api
        .purchaseBaggage({
          planId: baggageSelectedPlanId,
          planTitle: selectedPlan.information.title,
          firstName: baggagePassengerInfo.firstName,
          lastName: baggagePassengerInfo.lastName,
          email: baggagePassengerInfo.email,
          lat: baggageLocation.lat,
          lng: baggageLocation.lng,
          authToken,
          cardElement,
          revenue,
          details,
        })
        .then(purchaseData => {
          dispatch(baggagePurchaseSuccess(purchaseData));
          resolve(purchaseData);
        })
        .catch(error => {
          dispatch(baggagePurchaseError(error));
          reject(error);
        });
    });
  };
}
